import axios from "axios";
// import { setAlert } from './alert';

import {
  GET_DISCUSSION,
  GET_DISCUSSION_USERS,
  CREATE_DISCUSSION,
  END_DISCUSSION,
  DISCUSSION_ERROR,
  CLEAR_DISCUSSION_USERS,
} from "./types";

// Get Innovators to invite to Discussion
export const getUsers = (textValue) => async (dispatch) => {
  const formData = new FormData();
  formData.append("text", JSON.stringify(textValue));

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`/api/innovator/users`, formData, config);

    dispatch({
      type: GET_DISCUSSION_USERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: DISCUSSION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Create new course
export const createDiscussion = (discussion, keywords) => async (dispatch) => {
  const formData = new FormData();
  formData.append("discussion", JSON.stringify(discussion));
  formData.append("keywords", JSON.stringify(keywords));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/innovator/create_discussion`,
      formData,
      config
    );

    dispatch({
      type: CREATE_DISCUSSION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: DISCUSSION_ERROR,
      payload: {
        msg: err ? err.response.statusText : null,
        status: err ? err.response.status : null,
      },
    });
  }
};

// Get Live Discussion
export const getDiscussion = (channelid) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/innovator/${channelid}`);

    dispatch({
      type: GET_DISCUSSION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: DISCUSSION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// End Live Discussion
export const endDiscussion = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/innovator/end_discussion`);

    dispatch({
      type: END_DISCUSSION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: DISCUSSION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Clear Messages Users Search
export const clearUsers = () => async (dispatch) => {
  dispatch({ type: CLEAR_DISCUSSION_USERS });
};
